import { Api } from "../axios.config";

const path = "/sessions";

export const createSession = (payload) => Api.post(path, payload);
export const deleteSession = () => Api.delete(path);

export const forgotPassword = (payload) => Api.post("forgot_password", payload);
export const resetPassword = (payload) => Api.post("reset_password", payload);
